import React, { component, useState, useEffect } from 'react';
import Players from './components/Players/Players';
import ReactGA from 'react-ga';
import { colors } from './shared/config'
import styled, { keyframes } from "styled-components";
import { mediaQueries } from "./shared/config";
// import Landing from './assets/landing.png';
import Footer from './components/Footer';
import Landing from './components/Landing';
import Sticky from "./components/Sticky";
import ArticleGrid from "./components/ArticleGrid"
import MobilePlayers from "./components/Players/MobilePlayers"
//import {Router} from 'react-router-dom';
const MobileSection = styled.div ` 
height:24px;
padding-left: 5%;
padding-bottom: 5%;
padding-top: 8%;

font-family: Optima;
font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 24px;
text-transform: uppercase;

color: #FFFFFF;

text-transform: uppercase;
background-color: ${colors.background};
`
const Section = styled.div ` 
height: 44px;
padding-left: 10%;
padding-bottom: 5%;
padding-top:8%;

font-family: Optima;
font-style: normal;
font-weight: normal;
font-size: 36px;
line-height: 44px;
/* identical to box height */

text-transform: uppercase;
background-color: ${colors.background};
color: white;
`

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(
      'https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2022.basketball/'
    )
      .then((res) => res.json())
      .then((res) => setData(res.data['article.aml']));
  }, []);

  data && console.log(data);

  const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    console.log(isMobile);
    //console.log(data);
    media.addEventListener('change', () => {
        if (media.matches !== isMobile) {
          setIsMobile(media.matches);
        }
    });

    if (isMobile) {
      return (
        (data &&
          <>
              <Sticky />
              <Landing data={data}/>
              <MobileSection id="women">WOMEN'S BASKETBALL</MobileSection>
              <MobilePlayers data={data}  about={data.about_the_data}/>
              <MobileSection id="stories">STORIES</MobileSection>
              <ArticleGrid data={data.stories} />
              <MobileSection id="galleries">GALLERIES</MobileSection>
              <ArticleGrid data={data.galleries} />
              <Footer />
            </>
          )
      )
    }
    else {
      return (
        (data &&
        <>
            <Sticky />
            <Landing data={data}/>
            <Section id="women">WOMEN'S BASKETBALL</Section>
            <Players mf="f" data={data.womens}  about={data.about_the_data}/>
            <Section id="stories">STORIES</Section>
            <ArticleGrid data={data.stories} />
            <Section id="galleries">GALLERIES</Section>
            <ArticleGrid data={data.galleries} />
            <Footer />
          </>
        )
      );
    }
}

export default App;